/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { Dispatch } from '../redux';
import SigningDocument from '../components/common/Documents/SigningDocument';
import { DocumentsAPI } from '../api/common/documents';

export const setCurrentDocument = (document: SigningDocument) => {
  return (dispatch: Dispatch) => {
    dispatch({ type: 'SET_CURRENT_DOC', payload: document });
  };
};

export const setDocuments = (documents: DocumentsAPI.DocumentsResponse) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'SET_DOCUMENTS',
      payload: documents,
    });
  };
};

export const setSelectedDocument = (document: { id: string; pdfUrl?: string }) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'SET_SELECTED_DOC',
      payload: document,
    });
  };
};

export const setDocumentEditUrl = (editUrl: string | undefined) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'SET_EDIT_URL',
      payload: editUrl,
    });
  };
};
